<template>
  <div class="panel panel-default">
    <div class="panel-heading">Handle Client BackOffice</div>
    <div class="panel-body">
      <form @submit.prevent="updateHandleClient" name="handle-client">
        <div class="col-xs-6 padding-off">
            <label class="" for="handle-client" hidden>Handle Client</label>
            <input class="form-control" id="handle-client"  v-model="handleClient">
        </div>
            <div class="col-xs-6 _pr-0">
                <button class="btn-blue btn-block btn-small" type="submit">Atualizar</button>
            </div>    
      </form>
    </div>
  </div>
</template>
<script>
import WaitLoader from "@/components/loader/wait-loader";

export default {
  props: ["company_id"],
  data() {
    return {
      submitted: false,
      loading: false,
      handleClient: '',
    };
  },
  created() {
    this.loading = true;
    this.$http
      .get("/api/handle-client?company_id=" + this.company_id)
      .then((response) => {
        if (response.status === 200) {
          this.handleClient = response.data["handle_client"]
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
  components: {
    WaitLoader,
  },
  methods: {
    updateHandleClient() {
      this.$http
        .post("/api/admin/company/update/handleclient", {
          company_id: this.company_id,
          handle_client: this.handleClient
        })
        .then((response) => {
          if (response.status === 200) {
            location.reload();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>